import ApiRequests from "../apiRequests";

class AuthenticationService extends ApiRequests{
    constructor(){
        super("auth");
    }
}

export default AuthenticationService;